import { useCallback, useContext } from 'react';
import _get from 'lodash/get';
import _find from 'lodash/find';

import { APP_LANGUAGE } from 'commons/models/common';
import { AjaxContext, formatListData, AppContext, UserContext } from 'commons-ui';
import { UserDetailsContext } from '../../../context/userDetails';
import { ACTION } from '../../../constant';
import { EURL } from '../../../enum';

const useService = () => {
	const { postData } = useContext(AjaxContext);
	const { permissionsConfig } = useContext(UserContext);
	const {
		app: { appName }
	} = useContext(AppContext);
	const {
		selectedUser: { uid, level, deviceType }
	} = useContext(UserDetailsContext);

	const getCouponsData = useCallback(async () => {
		const permission = _find(permissionsConfig, { actionName: ACTION.getActiveCouponForUser });
		const result = await postData({
			endpoint: EURL.GET_ACTIVE_COUPON,
			queryParams: {
				appName
			},
			body: {
				uid,
				level,
				deviceType,
				language: APP_LANGUAGE.ENGLISH
			},
			customHeaders: {
				isMasked: permission?.isMasked || false
			}
		});

		const data = _get(result, ['data', 'data', 'coupons'], {});

		const listData = formatListData(data);
		const rowCount = _get(result, ['data', 'data', 'coupons', 'count'], 0);

		return { rowCount, data: listData };
	}, []);

	return { getCouponsData };
};

export default useService;
